import React, { Fragment } from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => {
  let addressPrefix = ownProps.address.substring(0, 6);
  let addressArray = [];

  for (let i = 6; i + 6 <= ownProps.address.length; i += 6) {
    addressArray.push(ownProps.address.substring(i, i + 6));
  }

  return {
    name: state.addressToName[ownProps.address],
    addressPrefix: addressPrefix,
    addressArray: addressArray
  };
};

const ConnectedAddressNameInline = ({name, addressPrefix, addressArray}) => {
  if (name) {
    return (<span className="c-address-name__address-name">{name}</span>);
  }

  return (
    <Fragment>
      <span className="c-address-name__address-prefix">{addressPrefix}</span>
      {addressArray.map(
        (a) => (<span style={{background: '#' + a}} key={a} className="c-address-name__color-code"></span>))}
    </Fragment>
  );
};

const AddressNameInline = connect(mapStateToProps)(ConnectedAddressNameInline);

export default AddressNameInline;


// WEBPACK FOOTER //
// ./src/components/Components/AddressNameInline.js